export let PERSENTASE_IKU = 0.4; //40%
export let POINT_MAX_IKU = {
  TP: 872 * PERSENTASE_IKU,
  AA: 1098 * PERSENTASE_IKU,
  L: 1863 * PERSENTASE_IKU,
  LK: 2436 * PERSENTASE_IKU,
  GB: 4294 * PERSENTASE_IKU,
};

export const updateIkuConfig = (persentaseIku: number) => {
  PERSENTASE_IKU = persentaseIku;
  POINT_MAX_IKU = {
    TP: 872 * PERSENTASE_IKU,
    AA: 1098 * PERSENTASE_IKU,
    L: 1863 * PERSENTASE_IKU,
    LK: 2436 * PERSENTASE_IKU,
    GB: 4294 * PERSENTASE_IKU,
  };
};

// export const IKU_LIST = [
//   {
//     iku: 1,
//     indikator: "Angka Efisiensi Edukasi",
//     persentase: {
//       tp: 0.1,
//       aa: 0.1,
//       l: 0.1,
//       lk: 0.1,
//       gb: 0.08,
//     },
//   },
//   {
//     iku: 2,
//     indikator: "Lulusan Bekerja/Wirausaha/Studi",
//     persentase: {
//       tp: 0.1,
//       aa: 0.1,
//       l: 0.1,
//       lk: 0.1,
//       gb: 0.08,
//     },
//   },
//   {
//     iku: 3,
//     indikator: "Mahasiswa Berkegiatan/Prestasi",
//     persentase: {
//       tp: 0.23,
//       aa: 0.22,
//       l: 0.11,
//       lk: 0.09,
//       gb: 0.07,
//     },
//   },
//   {
//     iku: 4,
//     indikator: "Rekognisi Internasional",
//     persentase: {
//       tp: 0,
//       aa: 0,
//       l: 0.1,
//       lk: 0.12,
//       gb: 0.13,
//     },
//   },
//   {
//     iku: 5,
//     indikator: "Kerjasama & Hilirisasi",
//     persentase: {
//       tp: 0.2,
//       aa: 0.2,
//       l: 0.13,
//       lk: 0.13,
//       gb: 0.1,
//     },
//   },
//   {
//     iku: 6,
//     indikator: "Publikasi Bereputasi",
//     persentase: {
//       tp: 0,
//       aa: 0,
//       l: 0.1,
//       lk: 0.11,
//       gb: 0.22,
//     },
//   },
//   {
//     iku: 7,
//     indikator: "Keterlibatan SDGs",
//     persentase: {
//       tp: 0.2,
//       aa: 0.2,
//       l: 0.14,
//       lk: 0.12,
//       gb: 0.08,
//     },
//   },
//   {
//     iku: 8,
//     indikator: "Kebijakan & Tri Dharma THK",
//     persentase: {
//       tp: 0,
//       aa: 0,
//       l: 0.1,
//       lk: 0.11,
//       gb: 0.12,
//     },
//   },
//   {
//     iku: 9,
//     indikator: "Pendapatan Non-Akademik",
//     persentase: {
//       tp: 0.17,
//       aa: 0.18,
//       l: 0.12,
//       lk: 0.12,
//       gb: 0.12,
//     },
//   },
// ];

export const IKU_LIST = [
  {
    iku: 1,
    indikator: "Angka Efisiensi Edukasi",
    persentase: { tp: 0, aa: 0, l: 0, lk: 0, gb: 0 },
  },
  {
    iku: 2,
    indikator: "Lulusan Bekerja/Wirausaha/Studi",
    persentase: { tp: 0, aa: 0, l: 0, lk: 0, gb: 0 },
  },
  {
    iku: 3,
    indikator: "Mahasiswa Berkegiatan/Prestasi",
    persentase: { tp: 0, aa: 0, l: 0, lk: 0, gb: 0 },
  },
  {
    iku: 4,
    indikator: "Rekognisi Internasional",
    persentase: { tp: 0, aa: 0, l: 0, lk: 0, gb: 0 },
  },
  {
    iku: 5,
    indikator: "Kerjasama & Hilirisasi",
    persentase: { tp: 0, aa: 0, l: 0, lk: 0, gb: 0 },
  },
  {
    iku: 6,
    indikator: "Publikasi Bereputasi",
    persentase: { tp: 0, aa: 0, l: 0, lk: 0, gb: 0 },
  },
  {
    iku: 7,
    indikator: "Keterlibatan SDGs",
    persentase: { tp: 0, aa: 0, l: 0, lk: 0, gb: 0 },
  },
  {
    iku: 8,
    indikator: "Kebijakan & Tri Dharma THK",
    persentase: { tp: 0, aa: 0, l: 0, lk: 0, gb: 0 },
  },
  {
    iku: 9,
    indikator: "Pendapatan Non-Akademik",
    persentase: { tp: 0, aa: 0, l: 0, lk: 0, gb: 0 },
  },
];

export const getDynamicIkuList = (configMultipliers?: any) => {
  if (!configMultipliers) return IKU_LIST;
  return IKU_LIST.map((row) => {
    const ikuKey = `IKU ${row.iku}`;
    const multipliers = configMultipliers[ikuKey];
    if (multipliers) {
      return {
        ...row,
        persentase: {
          ...row.persentase,
          tp: multipliers["TP"] ?? row.persentase.tp,
          aa: multipliers["AA"] ?? row.persentase.aa,
          l: multipliers["L"] ?? row.persentase.l,
          lk: multipliers["LK"] ?? row.persentase.lk,
          gb: multipliers["GB"] ?? row.persentase.gb,
        },
      };
    }
    return row;
  });
};

export const isInRENRange = (
  renCode: string | undefined,
  start: number,
  end: number,
): boolean => {
  if (!renCode) return false;
  const numMatch = renCode.match(/\d+/);
  if (numMatch) {
    const num = parseInt(numMatch[0], 10);
    return num >= start && num <= end;
  }
  return false;
};

export const calculateIKU7Koresponden = (
  pointSKS: number,
  jumlah: number,
  jumlahAnggota: number,
  isKetua: boolean,
  isKoresponden: boolean,
): number => {
  let authorPercent = 0.0;
  if (jumlahAnggota === 0) {
    authorPercent = 1.0;
  } else if (jumlahAnggota === 1) {
    if (isKetua && isKoresponden) {
      authorPercent = 0.6;
    } else if (isKetua) {
      authorPercent = 0.5;
    } else if (isKoresponden) {
      authorPercent = 0.5;
    } else {
      authorPercent = 0.4;
    }
  } else {
    if (isKetua && isKoresponden) {
      authorPercent = 0.6;
    } else if (isKetua) {
      authorPercent = 0.4;
    } else if (isKoresponden) {
      authorPercent = 0.4;
    } else {
      if (jumlahAnggota >= 2) {
        authorPercent = 0.2 / jumlahAnggota;
      } else {
        authorPercent = 0.0;
      }
    }
  }
  return jumlah * pointSKS * authorPercent;
};

export const calculateIKU7NonKoresponden = (
  pointSKS: number,
  jumlah: number,
  jumlahAnggota: number,
  isKetua: boolean,
): number => {
  let authorPercent = 0.0;
  if (jumlahAnggota === 0) {
    authorPercent = pointSKS;
  } else if (isKetua) {
    authorPercent = pointSKS;
  } else {
    authorPercent = pointSKS / jumlahAnggota;
  }
  return jumlah * authorPercent;
};

export const calculateIKU5Koresponden = (
  pointSKS: number,
  jumlah: number,
  jumlahAnggota: number,
  isKetua: boolean,
  isKoresponden: boolean,
): number => {
  let authorPercent = 0.0;
  if (jumlahAnggota === 0) {
    authorPercent = 1.0;
  } else if (jumlahAnggota === 1) {
    if (isKetua && isKoresponden) {
      authorPercent = 0.6;
    } else if (isKetua) {
      authorPercent = 0.5;
    } else if (isKoresponden) {
      authorPercent = 0.5;
    } else {
      authorPercent = 0.4;
    }
  } else {
    if (isKetua && isKoresponden) {
      authorPercent = 0.6;
    } else if (isKetua) {
      authorPercent = 0.4;
    } else if (isKoresponden) {
      authorPercent = 0.4;
    } else {
      if (jumlahAnggota >= 2) {
        authorPercent = 0.2 / jumlahAnggota;
      } else {
        authorPercent = 0.0;
      }
    }
  }
  return jumlah * pointSKS * authorPercent;
};

export const calculateIKU5NonKoresponden = (
  pointSKS: number,
  jumlah: number,
  jumlahAnggota: number,
  isKetua: boolean,
): number => {
  let authorPercent = 0.0;
  if (jumlahAnggota === 0) {
    authorPercent = pointSKS;
  } else if (isKetua) {
    authorPercent = pointSKS;
  } else {
    authorPercent = pointSKS / jumlahAnggota;
  }
  return jumlah * authorPercent;
};

export const calculateIKU4Koresponden = (
  pointSKS: number,
  jumlah: number,
  jumlahAnggota: number,
  isKetua: boolean,
  isKoresponden: boolean,
): number => {
  let authorPercent = 0.0;
  if (jumlahAnggota === 0) {
    authorPercent = 1.0;
  } else if (jumlahAnggota === 1) {
    if (isKetua && isKoresponden) {
      authorPercent = 0.6;
    } else if (isKetua) {
      authorPercent = 0.5;
    } else if (isKoresponden) {
      authorPercent = 0.5;
    } else {
      authorPercent = 0.4;
    }
  } else {
    if (isKetua && isKoresponden) {
      authorPercent = 0.6;
    } else if (isKetua) {
      authorPercent = 0.4;
    } else if (isKoresponden) {
      authorPercent = 0.4;
    } else {
      if (jumlahAnggota >= 2) {
        authorPercent = 0.2 / jumlahAnggota;
      } else {
        authorPercent = 0.0;
      }
    }
  }
  return jumlah * pointSKS * authorPercent;
};

export const calculateIKU4NonKoresponden = (
  pointSKS: number,
  jumlah: number,
  jumlahAnggota: number,
  isKetua: boolean,
): number => {
  let authorPercent = 0.0;
  if (jumlahAnggota === 0) {
    authorPercent = pointSKS;
  } else if (isKetua) {
    authorPercent = pointSKS;
  } else {
    authorPercent = pointSKS / jumlahAnggota;
  }
  return jumlah * authorPercent;
};

export const getColumnKey = (jabatan: string) => {
  if (!jabatan) return "tp";
  const j = jabatan.toLowerCase();
  if (j.includes("guru besar")) return "gb";
  if (j.includes("lektor kepala")) return "lk";
  if (j.includes("lektor")) return "l";
  if (j.includes("asisten ahli")) return "aa";
  return "tp";
};

export const getColumnLabel = (colKey: string) => {
  const map: Record<string, string> = {
    tp: "TP",
    aa: "AA",
    l: "L",
    lk: "LK",
    gb: "GB",
  };
  return map[colKey] || "TP";
};

export const calculateMaxPotentialIku = (
  activeProduct: any,
  jabatanFungsional: string,
  ikuList?: any[],
  pointSKS: number = 0,
  jumlah: number = 1,
  renCode: string = "",
  dynamicIkuList: any[] = IKU_LIST,
): { iku: number; point: number } | null => {
  let maxPotentialIku: number | null = null;
  let maxPointValue = -1;

  if (activeProduct?.details_parsed) {
    const colKey = getColumnKey(jabatanFungsional);
    const columnLabel = getColumnLabel(colKey);

    const getPotentialPoint = (ikuNum: number) => {
      const isAllowed =
        !activeProduct.iku ||
        new RegExp(`IKU\\s*${ikuNum}`, "i").test(activeProduct.iku);
      if (!isAllowed) return -1;

      const isKetua = activeProduct.details_parsed.is_ketua === true;
      const isKoresponden =
        activeProduct.details_parsed.is_koresponden === true;
      const jumlahAnggota =
        Number(activeProduct.details_parsed.jumlah_total_anggota) || 1;

      let persentase = 0;
      if (ikuNum === 5) {
        if (isInRENRange(renCode, 250, 279)) {
          persentase = calculateIKU5Koresponden(
            pointSKS,
            jumlah,
            jumlahAnggota,
            isKetua,
            isKoresponden,
          );
        } else {
          persentase = calculateIKU5NonKoresponden(
            pointSKS,
            jumlah,
            jumlahAnggota,
            isKetua,
          );
        }
      } else if (ikuNum === 4) {
        if (isInRENRange(renCode, 250, 279)) {
          persentase = calculateIKU4Koresponden(
            pointSKS,
            jumlah,
            jumlahAnggota,
            isKetua,
            isKoresponden,
          );
        } else {
          persentase = calculateIKU4NonKoresponden(
            pointSKS,
            jumlah,
            jumlahAnggota,
            isKetua,
          );
        }
      } else if (ikuNum === 7) {
        if (isInRENRange(renCode, 250, 279)) {
          persentase = calculateIKU7Koresponden(
            pointSKS,
            jumlah,
            jumlahAnggota,
            isKetua,
            isKoresponden,
          );
        } else {
          persentase = calculateIKU7NonKoresponden(
            pointSKS,
            jumlah,
            jumlahAnggota,
            isKetua,
          );
        }
      } else {
        persentase = 1.0; // Wait, for IKU 6, 8, etc. Maybe we leave it as 1.0
      }

      const maxPoint =
        POINT_MAX_IKU[columnLabel as keyof typeof POINT_MAX_IKU] || 0;
      const targetRow = dynamicIkuList.find((r) => r.iku === ikuNum);
      const persentaseIkuList =
        targetRow?.persentase?.[colKey as keyof typeof targetRow.persentase] ||
        0;

      // In the Go code: point := maxPoint * persentase / 10
      // We will follow the Go logic here precisely for returning the point
      if (ikuNum === 4 || ikuNum === 5 || ikuNum === 7) {
        return (maxPoint * persentaseIkuList * persentase) / 10;
      }

      return maxPoint * persentaseIkuList * persentase;
    };

    const pts = [4, 5, 7].map((num) => ({
      iku: num,
      point: getPotentialPoint(num),
    }));

    for (const p of pts) {
      let limitExceeded = false;
      let maxpointfinal = 0;
      let currentPoint = 0;
      if (ikuList && p.iku !== 6) {
        const matchedIkuData = ikuList.find(
          (data: any) => data.iku_code === `IKU ${p.iku}`,
        );

        // const colKey = getColumnKey(jabatanFungsional);
        // const columnLabel = getColumnLabel(colKey);
        // const globalMaxPoint =
        //   POINT_MAX_IKU[columnLabel as keyof typeof POINT_MAX_IKU] || 0;
        // const targetRow = IKU_LIST.find((r) => r.iku === p.iku);
        // const persentaseIkuList =
        //   targetRow?.persentase?.[
        //     colKey as keyof typeof targetRow.persentase
        //   ] || 0;

        let apiMaxPoint = matchedIkuData
          ? Number(
              p.iku === 7
                ? matchedIkuData.max_point
                : (matchedIkuData.max_point_full ?? matchedIkuData.max_point),
            )
          : NaN;

        if (!isNaN(apiMaxPoint) && apiMaxPoint > 0) {
          maxpointfinal = apiMaxPoint;
        }
        // else {
        //   maxpointfinal = globalMaxPoint * persentaseIkuList * 2;
        // }

        currentPoint = matchedIkuData
          ? Number(matchedIkuData.real_point) || 0
          : 0;

        if (maxpointfinal > 0 && currentPoint + p.point > maxpointfinal) {
          limitExceeded = true;
        }
      }
      console.log(
        `  -> Evaluated IKU ${p.iku} | Point: ${p.point} | LimitExceeded: ${limitExceeded} (Current: ${currentPoint}, Max: ${maxpointfinal})`,
      );

      if (!limitExceeded && p.point > maxPointValue && p.point >= 0) {
        maxPointValue = p.point;
        maxPotentialIku = p.iku;
      }
    }

    const activeIkuArray = activeProduct.iku
      ? activeProduct.iku
          .toUpperCase()
          .split(",")
          .map((s: string) => s.trim())
      : null;

    if (activeIkuArray && activeIkuArray.length <= 1) {
      if (activeIkuArray[0]) {
        const match = activeIkuArray[0].match(/IKU\s*(\d+)/i);
        if (match) {
          const forcedIku = parseInt(match[1]);
          let limitExceeded = false;
          let maxpointfinal = 0;
          let currentPoint = 0;
          if (ikuList && forcedIku !== 6) {
            const matchedIkuData = ikuList.find(
              (data: any) => data.iku_code === `IKU ${forcedIku}`,
            );

            const colKey = getColumnKey(jabatanFungsional);
            const columnLabel = getColumnLabel(colKey);
            const globalMaxPoint =
              POINT_MAX_IKU[columnLabel as keyof typeof POINT_MAX_IKU] || 0;
            const targetRow = dynamicIkuList.find((r) => r.iku === forcedIku);
            const persentaseIkuList =
              targetRow?.persentase?.[
                colKey as keyof typeof targetRow.persentase
              ] || 0;

            let apiMaxPoint = matchedIkuData
              ? Number(
                  forcedIku === 7
                    ? matchedIkuData.max_point
                    : (matchedIkuData.max_point_full ??
                        matchedIkuData.max_point),
                )
              : NaN;

            if (!isNaN(apiMaxPoint) && apiMaxPoint > 0) {
              maxpointfinal = apiMaxPoint;
            } else {
              maxpointfinal = globalMaxPoint * persentaseIkuList * 2;
            }

            currentPoint = matchedIkuData
              ? Number(matchedIkuData.real_point) || 0
              : 0;
            const potentialPoint = getPotentialPoint(forcedIku);
            if (
              maxpointfinal > 0 &&
              currentPoint + potentialPoint > maxpointfinal
            ) {
              limitExceeded = true;
            }
          }
          console.log(
            `  -> Forced IKU ${forcedIku} | LimitExceeded: ${limitExceeded} (Current: ${currentPoint}, Max: ${maxpointfinal})`,
          );
          if (!limitExceeded) {
            maxPotentialIku = forcedIku;
            maxPointValue = getPotentialPoint(forcedIku);
          } else {
            maxPotentialIku = null;
          }
        }
      }
    }
  }

  if (maxPotentialIku !== null) {
    return { iku: maxPotentialIku, point: maxPointValue };
  }
  return null;
};
